mutation linkCreation($scenarioId: ID!, $originId: ID!, $input: LinkCrudInput!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    linksCrud(input: $input) {
      skippedValidations
      commited
      payload {
        creates {
          link {
            id
            code
            bundle {
              id
              code
              __typename
            }
            groups {
              id
              code
              __typename
            }
            __typename
          }
          validationErrors {
            ... on GenericInvalidValidation {
              __typename
              reason
            }
            ...InvalidGroupCodeValidation
            ...InvalidFieldValidation
            ... on InvalidSectionChanges {
              validationErrors {
                ... on InvalidInput {
                  code
                }
                ... on InvalidComponentSize {
                  reason
                  capacity
                  component {
                    id
                    academicStandard
                  }
                  __typename
                }
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}

fragment InvalidGroupCodeValidation on InvalidGroupCodeValidation {
  rejected_groups {
    id
    code
    capacity
    __typename
  }
  allowed
  reason
  __typename
}

fragment InvalidFieldValidation on InvalidFieldValidation {
  value
  reason
  meta
  __typename
}
